import colors from '../tokens/colors';

export const phoneGetolo = {
  base: {
    countryCode: {
      backgroundColor: colors.ULTRA_LIGHT_GRAY,
      borderRight: `1px solid ${colors.PROFESSIONAL_BLUE}`,
      typography: 'body',
      width: {
        desktop: '3.5rem',
        mobile: '3.5rem',
      },
    },
  },
  states: {
    hover: {}, // used from `input.style.js`
    focus: {}, // used from `input.style.js`
    focusVisible: {}, // used from `input.style.js`
    disabled: {}, // used from `input.style.js`
  },
};

export const phoneDaDirekt = {
  base: {
    countryCode: {
      backgroundColor: 'transparent',
      borderRight: 'none',
      typography: 'body',
      width: {
        desktop: '3.5rem',
        mobile: '3.5rem',
      },
    },
  },
  states: {
    hover: {}, // used from `input.style.js`
    focus: {}, // used from `input.style.js`
    focusVisible: {}, // used from `input.style.js`
    disabled: {}, // used from `input.style.js`
  },
};

export const phoneDaKaufland = {
  base: {
    countryCode: {
      backgroundColor: 'transparent',
      borderRight: 'none',
      typography: 'p4',
      width: {
        desktop: '3.5rem',
        mobile: '3.5rem',
      },
    },
    input: {
      paddingLeft: 0,
    },
  },
  states: {
    hover: {}, // used from `input.style.js`
    focus: {}, // used from `input.style.js`
    focusVisible: {}, // used from `input.style.js`
    disabled: {}, // used from `input.style.js`
  },
};

export const phoneDaFressnapf = {
  base: {
    countryCode: {
      backgroundColor: colors.FRESSNAPF_BACKGROUND_TERTIARY,
      borderRight: `1px solid ${colors.FRESSNAPF_TEXT_SECONDARY}`,
      typography: 'p4',
      width: {
        desktop: '3.5rem',
        mobile: '3.5rem',
      },
    },
  },
  states: {
    hover: {}, // used from `input.style.js`
    focus: {}, // used from `input.style.js`
    focusVisible: {}, // used from `input.style.js`
    disabled: {}, // used from `input.style.js`
  },
};
